import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ill_approval_default.svg'


const _hoisted_1 = { class: "flex flex-col gap-6 flex-1 justify-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "mx-auto",
  style: {"width":"224px","height":"190px"},
  src: _imports_0,
  alt: "default"
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "text-center text-gray-lp-300 text-sm font-semibold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.message)
      ? (_openBlock(), _createBlock("p", _hoisted_3, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true)
  ]))
}